import { LeafletGeoJsonProxy } from './LeafletGeoJsonProxy.js';

export { LeafletOpusProxy };

class LeafletOpusProxy extends LeafletGeoJsonProxy {

    divIcon = new L.DivIcon({
        html: '<div class="opus-marker"><span>1</span></div>',
        iconSize: [0, 0]
    });

    constructor(vefLayer) {
        super(vefLayer);

        if ("markerClusterGroup" in L) {
            this.leafletLayer = L.markerClusterGroup({
                removeOutsideVisibleBounds: false,
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: true,
                zoomToBoundsOnClick: false,
                maxClusterRadius: 40,
                iconCreateFunction: function (cluster) {
                    const childCount = cluster.getChildCount()
                    return new L.DivIcon({
                        html: '<div class="opus-cluster"><span>' + childCount + '</span></div>',
                        className: 'marker-cluster',
                        iconSize: [0, 0]
                    })
                }
            });
            this.leafletLayer.on('clusterclick', (e) => {
                e.layer.spiderfy()
            });
        } else {
            this.leafletLayer = L.featureGroup();;
        }
    }

    setData(recorders) {
        this.leafletLayer.clearLayers();
        const markers = [];
        for (let i = 0; i < recorders.length; ++i) {

            let marker = null;
            if (this.vefLayer.useDivMarkers) {
                marker = L.marker({ lat: recorders[i].latitude, lng: recorders[i].longitude }, {
                    icon: this.divIcon
                });
            } else {
                marker = L.circleMarker({ lat: recorders[i].latitude, lng: recorders[i].longitude }, {
                    opacity: this.vefLayer.opacity,
                    fillOpacity: this.vefLayer.opacity * this.vefLayer.opacityRatio,
                    color: "#237cc9"
                }).bindTooltip("1", {
                    permanent: true,
                    opacity: 1,
                    direction: "center",
                    className: "opus-tooltip-label"
                });
            }

            const fire = (mouseEvent, eventName, addClickedFeature) => {
                const feature = {
                    type: "Feature",
                    properties: recorders[i],
                    geometry: {
                        type: "Point",
                        coordinates: [recorders[i].longitude, recorders[i].latitude]
                    }
                };
                if (addClickedFeature) this.clickedFeatures.push(feature);
                this.fire(eventName, {
                    feature: feature,
                    mouseEvent: mouseEvent
                });
            }
            marker.on("click", e => fire(e, "click", !this.vefLayer.hoverEvents))
            if (this.vefLayer.hoverEvents) {
                marker.on("mouseover", e => fire(e, "mouseover", true));
                marker.on("mouseout", e => fire(e, "mouseout", false));
            }
            markers.push(marker);
        }
        if (markers.length > 0) setTimeout(() => {
            markers.forEach(marker => this.leafletLayer.addLayer(marker))
        }, 0);
    }

}